import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { TextToolTip } from 'components';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { DashboardTabs } from './dashboardTabs';
import { MyTasksTabs, MyTasksEmptyStates, formatDueDate, getDueDateColor } from './constants';
import { FindLoad } from 'utils';
import { dashboardActions } from 'store';

const ACTION_TYPE = 'GET_DASHBOARD_MY_TASKS';

export const MyTasks = ({ item, handleDeleteWidget }) => {
    const [activeTab, setActiveTab] = useState('overdue');
    const { myTasks } = useSelector((state) => ({
        myTasks: state.dashboard.myTasks,
    }));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    const handleViewAll = (e) => {
        e.stopPropagation();
        navigate('/tasks');
    };

    const categorizedTasks = useMemo(() => {
        const result = { overdue: [], dueToday: [], upcoming: [] };
        const allTasks = myTasks?.tasks || [];
        const today = moment.utc().startOf('day');

        allTasks.forEach((task) => {
            if (!task?.dueDate) {
                result.upcoming.push(task);
                return;
            }
            const due = moment.utc(task.dueDate).startOf('day');
            const diff = today.diff(due, 'days');

            if (diff > 0) {
                result.overdue.push(task);
            } else if (diff === 0) {
                result.dueToday.push(task);
            } else {
                result.upcoming.push(task);
            }
        });
        return result;
    }, [myTasks?.tasks]);

    const currentTasks = categorizedTasks[activeTab] || [];
    const getCount = (key) => categorizedTasks[key]?.length || 0;

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell
            iconId={8}
            onClose={(e) => handleDeleteWidget(e, item)}
            onOpen={handleViewAll}
        >
            <div className="dashboard-tabbed-body">
                <DashboardTabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    tabs={MyTasksTabs.map((tab) => ({
                        key: tab.key,
                        label: tab.label,
                        count: getCount(tab.key),
                        countBg: tab?.background,
                        countColor: tab?.color,
                    }))}
                />

                <div className="main-dashboard-card-body" style={{ padding: 0 }}>
                    <div className="my-tasks-list-wrapper">
                        {currentTasks?.length > 0 ? (
                            currentTasks.map((task) => (
                                <div key={task?.id} className="my-tasks-item">
                                    <div className="my-tasks-item-info">
                                        <TextToolTip
                                            text={task?.title}
                                            content={task?.title}
                                            classNameText={`my-tasks-item-title ${task?.status === 'COMPLETED' ? 'my-tasks-item-title-completed' : ''}`}
                                        />

                                        <TextToolTip
                                            text={formatDueDate(task?.dueDate)}
                                            content={formatDueDate(task?.dueDate)}
                                            classNameText={`my-tasks-item-due-date`}
                                            textStyles={{ color: getDueDateColor(task?.dueDate) }}
                                        />
                                    </div>
                                </div>
                            ))
                        ) : (
                            <EmptyStateDashboard
                                iconId={8}
                                title={MyTasksEmptyStates[activeTab]?.title}
                                description={MyTasksEmptyStates[activeTab]?.description}
                            />
                        )}
                    </div>
                </div>
            </div>
        </DashboardWidgetShell>
    );
};
